import type { Strings } from './en'

export const de: Strings = {
  email: 'E-Mail',
  password: 'Passwort',
  name: 'Name',
  cancel: 'Abbrechen',
  continue: 'Weiter',
  or: 'oder',
  useDifferentEmail: 'Andere E-Mail verwenden',
  somethingWrong: 'Etwas ist schiefgelaufen',
  code6: '6-stelliger Code',
  resetCode: 'Zurücksetzungscode',
  newPassword: 'Neues Passwort',
  continueWithGoogle: 'Mit Google fortfahren',
  continueWithApple: 'Mit Apple fortfahren',
  continueWithEmail: 'Mit E-Mail fortfahren',
  back: 'Zurück',

  chooserTitle: 'Anmelden oder Konto erstellen',
  chooserSubtitle: 'Wähle, wie du fortfahren möchtest',
  emailTitle: 'Mit E-Mail fortfahren',
  emailSubtitle: 'Gib deine E-Mail ein, um fortzufahren',
  welcomeBack: 'Willkommen zurück',
  signIn: 'Anmelden',
  forgotPassword: 'Passwort vergessen?',
  createTitle: 'Konto erstellen',
  createAccount: 'Konto erstellen',
  confirmTitle: 'Bestätige deine E-Mail',
  confirmCta: 'Bestätigen & anmelden',
  resendCode: 'Code erneut senden',
  confirmNeeded: 'Diese E-Mail muss bestätigt werden. Gib den gesendeten Code ein.',
  confirmCodeSent: 'Wir haben dir einen 6-stelligen Code per E-Mail gesendet.',
  codeResent: 'Code erneut gesendet.',
  googleTitle: 'Mit Google anmelden',
  isGoogleAccount: 'ist ein Google-Konto',
  appleTitle: 'Mit Apple anmelden',
  isAppleAccount: 'ist ein Apple-Konto',
  googleNotConfigured: 'Die Google-Anmeldung ist nicht konfiguriert',
  resetTitle: 'Passwort zurücksetzen',
  resetSubtitle: 'Wir senden dir einen Code per E-Mail',
  sendResetCode: 'Code senden',
  resetCodeSent: 'Wir haben dir einen Zurücksetzungscode per E-Mail gesendet.',
  setNewTitle: 'Neues Passwort festlegen',
  setNewPassword: 'Neues Passwort festlegen',
  passwordUpdated: 'Passwort aktualisiert. Melde dich mit deinem neuen Passwort an.',

  yourAccount: 'Dein Konto',
  signOut: 'Abmelden',
  changePicture: 'Bild ändern',
  uploading: 'Wird hochgeladen…',
  preferredLanguage: 'Bevorzugte Sprache',
  saveChanges: 'Änderungen speichern',
  saved: 'Gespeichert',
  passwordSection: 'Passwort',
  changePassword: 'Passwort ändern',

  adjustPhoto: 'Foto anpassen',
  cropHint: 'Ziehen zum Verschieben · scrollen oder zwei Finger zum Zoomen.',
  savePhoto: 'Foto speichern',
  cropExportError: 'Das zugeschnittene Bild konnte nicht exportiert werden. Versuche ein anderes Foto.',

  missingCode: 'Autorisierungscode oder Verifier fehlt',
  backToSignIn: 'Zurück zur Anmeldung',
  signInFailed: 'Anmeldung fehlgeschlagen',

  signedOutTitle: 'Abgemeldet',
  signedOutBody: 'Sie wurden auf diesem Gerät von Ihrem WeApps-Konto abgemeldet.',
  goingBackIn: 'Zurück in {{n}}s…',
  returnToApp: 'Zurück',

  signingIn: 'Anmeldung läuft…',
  signingInSubtitle: 'Es dauert nur einen Moment.',

  // delete account (ISSUE-2026-07-20-240, ADR 0091)
  deleteTitle: 'Konto löschen',
  deleteIntro:
    'Sie können Ihr WeApps-Konto hier im Web löschen, ohne die App zu öffnen. Dies betrifft Ihr Konto auf der gesamten Plattform.',
  deleteButton: 'Konto löschen',
  deleteConfirmTitle: 'Ihr Konto endgültig löschen?',
  deleteConfirmBody:
    'Dies beendet Ihren Zugang und entfernt Ihr Konto in allen Organisationen, Gruppen und Kursen auf allen Geräten — Ihre Anmeldung funktioniert nirgends mehr. Wo das Gesetz es verlangt (zum Beispiel Finanzunterlagen früherer Käufe), werden einige Daten in anonymisierter Form aufbewahrt. Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden.',
  deleteConfirmCta: 'Ja, mein Konto löschen',
  deleteKeepCta: 'Konto behalten',
  deleteError: 'Die Löschung konnte nicht geplant werden. Bitte versuchen Sie es erneut.',
  deleteDoneTitle: 'Konto zur Löschung vorgemerkt',
  deleteDoneBody:
    'Ihr Konto wurde zur Löschung vorgemerkt und Ihr Zugang ist jetzt deaktiviert. Eine Anmeldung ist nicht mehr möglich.',
  deleteDoneCta: 'Fertig',

  footer: 'WeApps-Konto',
  language: 'Sprache',
  langEn: 'English',
  langPt: 'Português',
  langDe: 'Deutsch',
}
